import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=7d54fa02&scoped=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=ts"
export * from "./DefaultHeader.vue?vue&type=script&lang=ts"
import style0 from "./DefaultHeader.vue?vue&type=style&index=0&id=7d54fa02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54fa02",
  null
  
)

export default component.exports